import React, { useState, useEffect, useContext } from "react";
import "./Configurations.css";
import { UserContext } from "../../../context/UserContext";
import { BASE_URL } from "../../../constants";

const Configurations = () => {
  const [config, setConfig] = useState({
    providerName: "",
    email: "",
    phone: "",
    address: "",
    defaultUrgentDays: 5,
    paymentMethod: "",
  });

  const {
    user: { medical_provider_id: providerId },
  } = useContext(UserContext);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await fetch(
          `${BASE_URL}/api/medical-providers/${providerId}`
        );
        const data = await res.json();

        console.log(data);

        if (data.success && data.provider) {
          console.log("pppddd", data.provider);
          setConfig({
            providerName: data.provider.provider || "",
            email: data.provider.email
              ? data.provider.email
              : "exampleprovider@health.org",
            phone: data.provider.phone || "",
            address: data.provider.address || "",
            defaultUrgentDays: 5, // your default
            paymentMethod: "Bank Transfer", // default until backend provides it
          });
        }
      } catch (err) {
        console.error("Error fetching provider config:", err);
      }
    };

    fetchConfig();
  }, [providerId]);

  const handleChange = (e) => {
    setConfig({ ...config, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    console.log("Updated Config:", config);
    alert("Configuration updated successfully!");
  };

  // const updateProvider = async (providerId, updatedData) => {
  //   try {
  //     const response = await fetch(`${BASE_URL}/api/medical-providers/${providerId}`, {
  //       method: "PUT", // or PATCH if you use that version
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(updatedData),
  //     });

  //     const data = await response.json();

  //     if (data.success) {
  //       console.log("Provider updated:", data.updatedProvider);
  //       // Update local state or show success message
  //     } else {
  //       console.error("Update failed:", data.error);
  //     }
  //   } catch (err) {
  //     console.error("Error updating provider:", err);
  //   }
  // };

  return (
    <div className="config-page">
      <h2 className="config-title">Configurations</h2>

      <div className="config-card">
        <div className="config-grid">
          <div className="form-group">
            <label>Provider Name</label>
            <input
              name="providerName"
              value={config.providerName}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={config.email}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Phone</label>
            <input name="phone" value={config.phone} onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>Default Urgent Request Days</label>
            <input
              type="number"
              name="defaultUrgentDays"
              value={config.defaultUrgentDays}
              onChange={handleChange}
            />
          </div>

          <div className="form-group full-width">
            <label>Address</label>
            <textarea
              name="address"
              value={config.address}
              onChange={handleChange}
            />
          </div>

          <div className="form-group full-width">
            <label>Payment Method</label>
            <select
              name="paymentMethod"
              value={config.paymentMethod}
              onChange={handleChange}
            >
              <option value="Bank Transfer">Bank Transfer</option>
              <option value="Cheque">Cheque</option>
              <option value="PayPal">PayPal</option>
            </select>
          </div>
        </div>

        <div className="btn-container">
          <button className="save-btn" onClick={handleSave}>
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default Configurations;
